import axios, { AxiosInstance } from "axios";
import { AXIOS_TIMEOUT } from "@/utils/const";
import { requestInterceptor } from "./interceptors/requestInterceptor";
import { responseInterceptor } from "./interceptors/responseInterceptor";

/**
 * Base Axios instance configuration
 */
const baseAPI: AxiosInstance = axios.create({
  baseURL: `${
    process.env.NODE_ENV === "development"
      ? process.env.VUE_APP_LOCAL_SERVER_URL
      : process.env.VUE_APP_SERVER_URL
  }/${process.env.VUE_APP_VERSION}`,
  headers: {
    "Content-type": "application/json",
  },
  timeout: AXIOS_TIMEOUT,
  withCredentials: true,
});

// Register request interceptor
baseAPI.interceptors.request.use(requestInterceptor.onFulfilled, requestInterceptor.onRejected);

// Register response interceptor
baseAPI.interceptors.response.use(responseInterceptor.onFulfilled, responseInterceptor.onRejected);

export default baseAPI;
